import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GenericModule } from '../generic/index';

import { PopoverComponent } from './popover.component';
import { PopoverService } from './popover.service';

export { PopoverComponent, IPopoverSize } from './popover.component';
export { PopoverService } from './popover.service';

@NgModule({
  declarations: [
    PopoverComponent
  ],
  imports: [
    CommonModule,
    GenericModule
  ],
  exports: [
    PopoverComponent
  ],
  providers: [
    PopoverService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PopoverModule { }
